import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';

interface manageVisualsInfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class ManageVisualsService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi
  ) { }

  createManageVisuals(visualDetails){
    return this.http.post<manageVisualsInfo>(this.restAPI.CREATE_MANAGE_VISUALS,JSON.stringify(visualDetails), { headers: this.headers })
  }

  retreiveManageVisualsData() {
    return this.http.get<manageVisualsInfo>(this.restAPI.RETRIEVE_MANAGE_VISUALS, { headers: this.headers })
  }

  deleteManageVisualsData(visualId) {
    return this.http.get<manageVisualsInfo>(this.restAPI.DELETE_MANAGE_VISUALS+"/"+visualId, { headers: this.headers })
  }

  retreiveManageVisualsDataOnDatasetId(datasetId) {
    return this.http.get<manageVisualsInfo>(this.restAPI.RETRIEVE_MANAGE_VISUALS_ON_DATASET_ID+"/"+datasetId, { headers: this.headers })
  }
  
  
}
 